import { render, staticRenderFns } from "./ShotReview.vue?vue&type=template&id=521cad8f&scoped=true"
import script from "./ShotReview.vue?vue&type=script&lang=js"
export * from "./ShotReview.vue?vue&type=script&lang=js"
import style0 from "./ShotReview.vue?vue&type=style&index=0&id=521cad8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521cad8f",
  null
  
)

export default component.exports